module.exports = __webpack_public_path__ + "media/images/flags/NZ-1786506a2644f0d9e1f8d510b35fff3f.svg";